function init(){
  document.body.style.colorScheme = localStorage.getItem('color-scheme')
}
init()

export function getPreference(){
  return localStorage.getItem('color-scheme')
}

export function changePreference(value : "light"|"dark"|undefined){
  if(value===undefined){
    localStorage.removeItem('color-scheme');
  }else{
    localStorage.setItem('color-scheme',value);
  }
  init()
}